export const buildSearchUrl = (query: string, communityPath: string, topicPath?: string) => {
  const params = new URLSearchParams()
  query && params.set('q', query)
  topicPath && params.set('topicPath', topicPath)
  return `/community/${communityPath}/search?${params.toString()}`
}
